const courseModule = [
  {
    path: '/course-modules/:uuid/content',
    name: 'course-modules.content.list',
    component: () => import('@/views/coursemodulecontent/CourseModuleContentList.vue'),
  },
]

export default courseModule
